export const TASK_STATUS = {
  TODO: 'To Do',
  IN_PROCESS: 'In Process',
  IN_REVIEW: 'In Review',
  IN_REVIEW_BY_OTHERS: 'In Review By Others',
  COMPLETED: 'Completed',
  ARCHIVED: 'Archived',
  HELP_REQUIRED: 'Help Required',
  HELP_REQUIRED_BY_OTHERS: 'Help Required By Others',
  PENDING: 'Pending',
} as const;

export const COLORS = {
  priority: {
    low: '#10b981',
    medium: '#f59e0b',
    high: '#ef4444',
  },
  status: {
  "To Do": "badge-todo",
  "In Process": "badge-in-process",
  "In Review": "badge-in-review",
  "Completed": "badge-completed",
  "Archived": "badge-archived",
  "Help Required": "badge-help-required",
  },
} as const;

export const TASK_PRIORITIES = {
  LOW: 'Low',
  MEDIUM: 'Medium',
  HIGH: 'High',
} as const;

export const FREQUENCY_OPTIONS = {
  NONE: 'None',
  MONTHLY: 'Monthly',
  QUARTERLY: 'Quarterly',
  YEARLY: 'Yearly',
} as const;

export const TIME_FORMATS = {
  MINUTES: 'Minutes',
  HOURS: 'Hours',
} as const;

export const DATE_FORMATS = {
  'DD/MM/YYYY': 'dd/MM/yyyy',
  'MM/DD/YYYY': 'MM/dd/yyyy',
  'YYYY-MM-DD': 'yyyy-MM-dd',
} as const;

export const INVOICE_STATUS = {
  PENDING: 'Pending',
  GENERATED: 'Generated',
  SENT: 'Sent',
  PAID: 'Paid',
  CANCELLED: 'Cancelled',
  DONE: 'Done',
} as const;

export const USER_ROLES = {
  ADMIN: 'Admin',
  // TEAM_LEADER: 'Team Leader',
  TEAM_MEMBER: 'Team Member',
} as const;

export const USER_STATUS = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  INVITED: 'Invited',
} as const;

export const API_ENDPOINTS = {
  BASE_URL: import.meta.env.VITE_API_URL || 'http://localhost:8000/api',
  TIMEOUT: 30000,
} as const;

export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 20,
  PAGE_SIZE_OPTIONS: [10, 20, 50, 100],
} as const;

export const FILE_UPLOAD = {
  MAX_SIZE: 10 * 1024 * 1024, // 10MB
  ALLOWED_TYPES: {
    CSV: '.csv',
    EXCEL: '.xlsx,.xls',
    PDF: '.pdf',
  },
} as const;



export const KEYBOARD_SHORTCUTS = {
  NEW_TASK: 'ctrl+n,cmd+n',
  SAVE: 'ctrl+s,cmd+s',
  DELETE: 'delete',
  COPY: 'ctrl+c,cmd+c',
  PASTE: 'ctrl+v,cmd+v',
  SELECT_ALL: 'ctrl+a,cmd+a',
  EXPORT: 'ctrl+e,cmd+e',
  SEARCH: 'ctrl+f,cmd+f',
  ESCAPE: 'escape',
} as const;